class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('.cart__heading').addEventListener('click', this.changeToCart.bind(this));
    this.querySelector('.wishlist__heading').addEventListener('click', this.changeToWish.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  changeToCart() {
    this.querySelector('.cart__drawer').classList.add('cart--focus');
    this.querySelector('.cart__drawer').classList.remove('wishlist--focus');
  }
  changeToWish() {
    this.querySelector('.cart__drawer').classList.remove('cart--focus');
    this.querySelector('.cart__drawer').classList.add('wishlist--focus');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help

    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.body.classList.add('cart--open');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );
  }

  close() {
    this.classList.remove('active');
    //removeTrapFocus(this.activeElement);
    document.body.classList.remove('cart--open');
    var that = this;
    setTimeout(function () {
      that.changeToCart();
    }, 400);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.querySelector('.cart__heading').addEventListener('click', this.changeToCart.bind(this));
      this.querySelector('.wishlist__heading').addEventListener('click', this.changeToWish.bind(this));
      checkWishlist();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

/*class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);*/

class wishadd extends HTMLElement {
  constructor() {
    super();
    var that = this;
    this.button = this.querySelector('.button--fast-wishlist');
    this.parent = this.button.closest('.wishlist__item');
    this.button.addEventListener('click', this.onButtonClick.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.errorContainer = this.querySelector('.wishadd__error');
    this.lang = document.querySelector('html').getAttribute('lang');
  }

  onButtonClick(event) {
    var id = this.button.getAttribute('data-id');
    if (id) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData();
      this.querySelector('.loading__spinner').classList.remove('hidden');

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      formData.append('quantity', 1);
      formData.append('id', id);

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            console.log('ppp');
            this.handleErrorMessage(response.description);

            // const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            // if (!soldOutMessage) return;
            // soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            // window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          this.cart.changeToCart();
          var wishlist = window.localStorage.getItem('wishlist');
          let wi = response.handle;
          wishlist = wishlist.replace(wi, '');
          wishlist = wishlist.replaceAll(';;', ';');
          if (wishlist.length <= 2) {
            wishlist = '';
          }
          window.localStorage.setItem('wishlist', wishlist);
          let that = this;
          setTimeout(function () {
            that.cart.renderContents(response);
          }, 200);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          let that = this;
          setTimeout(function () {
            that.querySelector('.loading__spinner').classList.add('hidden');
          }, 200);
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          //this.querySelector('.loading__spinner').classList.add('hidden');
        });
    }
  }

  handleErrorMessage(error) {
    
    let errorLanguage =
      this.lang == 'es'
        ? 'No puedes añadir más unidades de este artículo a la cesta'
        : this.lang == 'fr'
        ? 'Vous ne pouvez pas ajouter d&apos;autres unités de cet article à votre panier'
        : 'You cannot add more units of this item to your basket';
    this.errorContainer.innerHTML = errorLanguage;
    this.errorContainer.toggleAttribute('hidden');
  }
}
customElements.define('wish-add', wishadd);
